import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService } from './auth.service';


@Injectable()
export class AuthGuardService implements CanActivate{

  constructor(private router: Router,private authService: AuthService) { 

  }
  canActivate(route: ActivatedRouteSnapshot,state: RouterStateSnapshot): boolean {

    if (this.authService.isLoggedIn()) {
      return true;
    }

    this.router.navigate(['/login']);
    return false;
  }

}



// WEBPACK FOOTER //
// ./src/app/auth-guard.service.ts